import React from 'react'
import innerStyles from "./InnerStyles.module.css"
import { useState } from 'react'
import axios from 'axios';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';

const ContactUs = () => {
  const[name,setName]=useState("");
  const[email,setEmail]=useState("")
  const[phone,setPhone]=useState("")
  const[subject,setSubject]=useState("")
  const[message,setMessage]=useState("")
  const[loading,setLoading]=useState(false)

  const addServiceData=(e)=>{
    if(loading) return;
    setLoading(true);
    e.preventDefault();
    axios.post(`https://backendsurgylife-1.onrender.com/contactus`,{
      name,
      email,
      phone,
      subject,
      message,
    })
    .then((res)=>{
      // alert(res.data)

      alert("✅  Mail Sent Successfully")
      setName("")
      setEmail("");
      setPhone("");
      setSubject("");
      setMessage("");
    })
    .catch((err)=>{
      alert("Error Unable to Send EMail")
    })
    .finally(()=>{
      setLoading(false);
    })
  }
  return (
      <main>
           
                   <section className={innerStyles.breadgum}>
                       <div className='container'>
                           <div className='row'>
                               <div className='col-md-12'>
                                   <h1>Contact Us</h1>
                               </div>
                           </div>
                       </div>
                   </section>

                   <section className='py-5'>
                    <div className='container'>
                      <div className='row'>
                        <div className='col-md-7'>
                        <form className={innerStyles.bx_shadow} onSubmit={addServiceData}>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='mb-4'>

                                <input type='text' 
                                name='sname'
                                 className='form-control'
                                 placeholder='Name'
                                 value={name}
                                 onChange={(e)=>setName(e.target.value)}
                                 required //Mandatory
                                 />
                              </div>
                            </div>

                             <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='email'
                                 className='form-control'
                                 placeholder='Email'
                                 value={email}
                                 onChange={(e)=>setEmail(e.target.value)}
                                     required //Mandatory

                                 />
                              </div>
                            </div>


                          </div>
                          
                           



                            <div className='row'>
                            <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='phone'
                                 className='form-control'
                                 placeholder='Phone'
                                 value={phone}
                                 onChange={(e)=>setPhone(e.target.value)}
                                                                  required //Mandatory

                                 />
                              </div>
                            </div>
                              <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='subject'
                                 className='form-control'
                                 placeholder='Subject'
                                 value={subject}
                                 onChange={(e)=>setSubject(e.target.value)}
                                                                  required //Mandatory

                                 />
                              </div>
                            </div>

                          </div>


                                 
                          

                              <div className='row'>
                            <div className='col-md-12'>
                              <div className='mb-4'>
                                <textarea 
                                name='message'
                                 className='form-control'
                                 placeholder='Message'
                                 value={message}
                                 onChange={(e)=>setMessage(e.target.value)}
                                 rows='3'
                                                                  required //Mandatory

                                 > </textarea>
                              </div>

                                 {/* <input type='submit'
                                 value='Send Message'
                                 className='btn btn-success'
                                 /> */}
  <div className='mb-3'>
                                    <button type='submit' className={`btn btn-success
                                       d-flex 
                                       align-items-center
                                       justify-content-center
                                       gap-2 ${innerStyles.btn}
                                       `}
                                       disabled={loading}
                                       >
                                        {
                                          loading && (
                                            <div className='spinner-border spinner-border-sm text-light ' role='status'>
                                              <span className='visually-hiiden'>Loading ...</span>
                                            </div>
                                          )}

                                            {loading ? "Sending..": "Send Message"}
                                    </button>
                                  </div>
                            </div>
                          </div>
                        </form>
                        </div>
                       
                       <div className='col-md-1'></div>
                        <div className='col-md-4'>
                           <div >
                               <h5 className='mb-3 text-primary'>Image Hospital</h5>
                               <p> <span className={innerStyles.StarIcon}><StarIcon/> </span>  <span className={innerStyles.StarIcon}><StarIcon/> </span>    <span className={innerStyles.StarIcon}><StarIcon/> </span>  <span className={innerStyles.StarIcon}><StarIcon/> </span> <span className={innerStyles.StarIcon}><StarHalfIcon/> </span>    4.6 Ratings </p>
                               <p>         <span className='text-primary'><LocationOnIcon/></span>
                                    Hospital 4/1, Hitech City Rd <br/>
                             Arunodaya Colony, Vittal Rao Nagar <br/>
                               Madhapur, Hyderabad, <br/>
                               Telangana 500081</p>
                               <p><a className={innerStyles.contact} href='https://imagehospitals.in/contact-us/'> <span className='text-primary'><LocalPhoneIcon/></span> 91+ 9160610000</a> </p>
                             <p className='mb-3'>   <a className= {innerStyles.contact} href='https://imagehospitals.in/contact-us/'> <span className='text-primary'><MailOutlineIcon/></span> info@imagehospitals.in </a> 
                          </p>

                           </div>
                        </div>

                      </div>
                    </div>
                   </section>

                    <section>

<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.3206541363757!2d78.38352907498664!3d17.44436018345252!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb915fde1657b3%3A0x8f160db117e89a9a!2sImage%20Hospitals!5e0!3m2!1sen!2sin!4v1755192519656!5m2!1sen!2sin" ></iframe>                
                    </section>
                  

                   </main>
  )
}

export default ContactUs
